import React, { useState } from "react";
import {
  Box,
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  TextField,
  Divider,
  Typography,
  Checkbox,
  Fab,
  Button,
} from "@mui/material";
import Layout from "../components/layout/Layout";
import { getProfessionalData } from "../companyformdata"; // Import the new function
import Kyc from "./Kyc";

const Professional = () => {
  const {
    professionalInfoFields,
    genderOptions,
    registrationInfoFields,
    taxInfoFields,
    bankDetailsFields,
    supportingDocuments,
  } = getProfessionalData();

  const [professionalFormData, setProfessionalFormData] = useState({
    personalInfo: {},
    registrationInfo: {},
    taxInfo: {
      amlCompliance: "",
    },
    bankInfo: {},
    supportingDocs: {},
  });

  const [gender, setGender] = useState("");

  const handleInputChange = (section, field, value) => {
    const updatedValues = { ...professionalFormData };
    updatedValues[section][field] = value;
   
    setProfessionalFormData(updatedValues);
  };

  const handleGenderChange = (event) => {
    setGender(event.target.value);
   
  };

  const handleProfessionalClick = async (e) => {
    // e.preventDefault();
    const dataToSend = {
      gender,
      ...professionalFormData,
    };


  
  };

  return (
    <>
      {/* <Kyc /> */}
      <Box
        sx={{ flexGrow: 1, marginBottom: "10px", marginTop: "70px" }}
        className="w-100"
      >
        <Grid
          container
          spacing={2}
          justifyContent="flex-center"
          className="justify-content-center mt-3"
        >
          <Grid item xs={10} className="">
            <Box
              sx={{
                padding: "16px",
                background:
                  "linear-gradient(90deg, rgba(181,178,235,1) 10%, rgba(189,206,247,1) 35%, rgb(251 172 101 / 99%) 80%)",
              }}
            >
              <h5 className="fw-bold">Personal Information</h5>
              <Grid container spacing={2} direction="row" className="pb-3">
                {professionalInfoFields.slice(0, 5).map((professionalinfo) => {
                  return (
                    <Grid item xs={3} key={professionalinfo.id}>
                      <TextField
                        type={professionalinfo.type}
                        fullWidth
                        placeholder={professionalinfo.placeholder}
                        variant="outlined"
                        name={professionalinfo.id}
                        value={
                          professionalFormData.personalInfo[
                            professionalinfo.id
                          ] || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "personalInfo",
                            professionalinfo.id,
                            e.target.value
                          )
                        }
                        sx={{
                          border: "1px solid grey",
                          borderRadius: "6px",
                          fontSize: "0.7rem",
                        }}
                      />
                    </Grid>
                  );
                })}
                <Grid container spacing={2} direction="row" className="pb-3">
                  <Grid item xs={6}>
                    <div className="d-flex align-items-center">
                      <FormControl component="fieldset">
                        <p className="fw-bold text-start ms-3 mt-3 mb-0">
                          Gender:
                        </p>
                        <RadioGroup
                          aria-label="company-type"
                          name="gender"
                          className="ms-3"
                          value={gender}
                          onChange={handleGenderChange}
                          row // To display the radio buttons inline
                        >
                          {genderOptions.options.map((gender, index) => {
                            return (
                              <FormControlLabel
                                key={index}
                                value={gender.value}
                                control={<Radio />}
                                label={gender.label}
                              />
                            );
                          })}
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </Grid>
                </Grid>
                <p className="fw-bold ms-3" gutterBottom>
                  Enter Your Nationality
                </p>
                <Grid container spacing={2} className="ms-1">
                  {professionalInfoFields
                    .slice(5, 7)
                    .map((professionalinfo) => {
                      return (
                        <Grid item xs={3} key={professionalinfo.id}>
                          <TextField
                            fullWidth
                            placeholder={professionalinfo.placeholder}
                            name={professionalinfo.name}
                            value={
                              professionalFormData.personalInfo[
                                professionalinfo.id
                              ] || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "personalInfo",
                                professionalinfo.id,
                                e.target.value
                              )
                            }
                            required
                            variant="outlined"
                            sx={{
                              border: "1px solid grey",
                              borderRadius: "6px",
                              fontSize: "0.7rem",
                            }}
                          />
                        </Grid>
                      );
                    })}
                </Grid>
                <p className="fw-bold text-start ms-3 mt-3 mb-0 w-100">
                  Residential Address:
                </p>
                {professionalInfoFields.slice(7, 12).map((professionalinfo) => {
                  return (
                    <Grid item xs={3} key={professionalinfo.id}>
                      <TextField
                        fullWidth
                        placeholder={professionalinfo.placeholder}
                        name={professionalinfo.id}
                        value={
                          professionalFormData.personalInfo[
                            professionalinfo.id
                          ] || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "personalInfo",
                            professionalinfo.id,
                            e.target.value
                          )
                        }
                        variant="outlined"
                        sx={{
                          border: "1px solid grey",
                          borderRadius: "6px",
                          fontSize: "0.7rem",
                        }}
                      />
                    </Grid>
                  );
                })}
                <p className="fw-bold text-start ms-3 mt-3 mb-0 w-100">
                  Office Address (if different from residential address)::
                </p>
                {professionalInfoFields.slice(7, 12).map((professionalinfo) => {
                  return (
                    <Grid item xs={3} key={professionalinfo.id}>
                      <TextField
                        fullWidth
                        placeholder={professionalinfo.placeholder}
                        name={professionalinfo.id}
                        value={
                          professionalFormData.personalInfo[
                            professionalinfo.id
                          ] || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "personalInfo",
                            professionalinfo.id,
                            e.target.value
                          )
                        }
                        variant="outlined"
                        sx={{
                          border: "1px solid grey",
                          borderRadius: "6px",
                          fontSize: "0.7rem",
                        }}
                      />
                    </Grid>
                  );
                })}
                <p className="fw-bold text-start ms-3 mt-3 mb-0 w-100">
                  Contact Information:
                </p>
                {professionalInfoFields
                  .slice(12, 17)
                  .map((professionalinfo) => {
                    return (
                      <Grid item xs={3} key={professionalinfo.id}>
                        <TextField
                          fullWidth
                          placeholder={professionalinfo.placeholder}
                          name={professionalinfo.id}
                          value={
                            professionalFormData.personalInfo[
                              professionalinfo.id
                            ] || ""
                          }
                          onChange={(e) =>
                            handleInputChange(
                              "personalInfo",
                              professionalinfo.id,
                              e.target.value
                            )
                          }
                          variant="outlined"
                          sx={{
                            border: "1px solid grey",
                            borderRadius: "6px",
                            fontSize: "0.7rem",
                          }}
                        />
                      </Grid>
                    );
                  })}
              </Grid>
              <Divider
                variant="middle"
                className="mt-3 mb-3"
                sx={{ borderBottomWidth: "2px", borderColor: "#0454bf" }}
              />
              <h5 className="fw-bold">Professional Information</h5>
              <p className="fw-bold float-start">Professional Registration:</p>
              <Grid container spacing={2}>
                {registrationInfoFields.map((registrationinfo) => {
                  return (
                    <Grid item xs={3} key={registrationinfo.id}>
                      <TextField
                        fullWidth
                        placeholder={registrationinfo.placeholder}
                        name={registrationinfo.id}
                        value={
                          professionalFormData.registrationInfo[
                            registrationinfo.id
                          ] || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "registrationInfo",
                            registrationinfo.id,
                            e.target.value
                          )
                        }
                        variant="outlined"
                        sx={{
                          border: "1px solid grey",
                          borderRadius: "6px",
                          fontSize: "0.7rem",
                        }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
              <Divider
                variant="middle"
                className="mt-4 mb-3"
                sx={{ borderBottomWidth: "2px", borderColor: "#0454bf" }}
              />
              <h5 className="fw-bold mt-3">Tax Information</h5>
              <Grid container spacing={2} alignItems="center">
                {/* Tax Identification Number */}
                {taxInfoFields.map((taxinfo) => {
                  return (
                    <Grid item xs={4} key={taxinfo.id}>
                      <TextField
                        fullWidth
                        type={taxinfo.type}
                        placeholder={taxinfo.placeholder}
                        value={professionalFormData.taxInfo[taxinfo.id] || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "taxInfo",
                            taxinfo.id,
                            e.target.value
                          )
                        }
                        variant="outlined"
                        sx={{
                          border: "1px solid grey",
                          borderRadius: "6px",
                          fontSize: "0.7rem",
                        }}
                      />
                    </Grid>
                  );
                })}

                {/* Anti-Money Laundering (AML) Compliance */}
                <h6 className="fw-bold text-start w-100 mt-3 ms-3">
                  Anti-Money Laundering (AML) Compliance:
                </h6>
                <Grid item xs={4}>
                  <Typography
                    component="p"
                    className="ms-0"
                    sx={{
                      fontSize: "0.9rem",
                      // marginBottom: "8px",
                    }}
                  >
                    Has the company implemented AML policies?
                  </Typography>
                  <RadioGroup
                    row
                    name="amlCompliance"
                    value={professionalFormData.taxInfo.amlCompliance || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "taxInfo",
                        "amlCompliance",
                        e.target.value
                      )
                    }
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                      sx={{ fontSize: "0.7rem" }}
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                      sx={{ fontSize: "0.7rem" }}
                    />
                  </RadioGroup>
                </Grid>
              </Grid>
              <Divider
                variant="middle"
                className="mt-4 mb-3"
                sx={{ borderBottomWidth: "2px", borderColor: "#0454bf" }}
              />
              <h5 className="fw-bold mt-">Banking Information</h5>
              <Grid container spacing={2} alignItems="center">
                {/* Primary Bank */}
                {bankDetailsFields.map((bankinfo) => {
                  return (
                    <Grid item xs={4} key={bankinfo.id}>
                      <TextField
                        fullWidth
                        placeholder={bankinfo.placeholder}
                        value={professionalFormData.bankInfo[bankinfo.id] || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "bankInfo",
                            bankinfo.id,
                            e.target.value
                          )
                        }
                        variant="outlined"
                        sx={{
                          border: "1px solid grey",
                          borderRadius: "6px",
                          fontSize: "0.7rem",
                        }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
              <h6 className="fw-bold text-start w-100 mt-4 mb-3">
                Supporting Documents
              </h6>
              <Grid container spacing={2} alignItems="center">
                <p className="fw-bold text-start w-100 ms-3 mb-0">
                  Documents Required:
                </p>
                {supportingDocuments.map((doc) => {
                  return (
                    <Grid item xs={6} className="text-start" key={doc.id}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name={doc.id}
                            // checked={professionalFormData[doc.id] || false}
                          />
                        }
                        value={
                          professionalFormData.supportingDocs[doc.id] || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "supportingDocs",
                            doc.id,
                            e.target.value
                          )
                        }
                        label={doc.label}
                      />
                    </Grid>
                  );
                })}
              </Grid>
              <Divider
                variant="middle"
                className="mt-4 mb-3"
                sx={{ borderBottomWidth: "2px", borderColor: "#0454bf;" }}
              />
              <Button onClick={handleProfessionalClick}>
                <Fab
                  variant="extended"
                  size="small"
                  sx={{
                    width: "100px",
                    height: "25px",
                    backgroundColor: "#e7c305",
                  }}
                >
                  <span style={{ fontSize: "0.6rem" }} className="fw-bold">
                    Submit
                  </span>
                </Fab>
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Professional;
